<script lang="ts">
  // The mockup's 4-up stat strip: a hairline grid of StatCards sharing 1px
  // dividers, wrapped in one rounded card. Pure layout — items are plain
  // data, no per-item logic lives here.
  import StatCard from './StatCard.svelte';

  const {
    items
  }: { items: { label: string; value: string | number; unit?: string }[] } = $props();
</script>

<div
  class="grid gap-px overflow-hidden rounded-2xl border border-toyama-cloudy-gray bg-toyama-cloudy-gray"
  style="grid-template-columns:repeat(auto-fit,minmax(150px,1fr))"
>
  {#each items as item (item.label)}
    <StatCard label={item.label} value={item.value} unit={item.unit} />
  {/each}
</div>
